import React from 'react';
import { Block, Flex, Spacer, Text } from 'vcc-ui';

export const Avatar = ({ name, email, title, img, align = 'end' }) => (
  <Flex
    extend={{
      flexDirection: 'row',
      justifyContent: align === 'end' && 'flex-end',
    }}
  >
    <Block
      extend={{
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        overflow: 'hidden',
      }}
    >
      <Block alt={name} as="img" extend={{ maxWidth: '100%' }} src={img} />
    </Block>
    <Spacer />
    <Text variant="bates">
      <Text as="a" href={`mailto:${email}`} subStyle="inline-link">
        {name}
      </Text>
      <br />
      {title}
    </Text>
  </Flex>
);
